import { firstValueFrom } from 'rxjs';
import { Application } from '@domain/Application';
import { HttpResponse } from '@domain/HttpResponse';
import { ApplicationService } from '@services/application.service';
import { SinTramite } from './tramite';

/**
 * La matricula, por su id (SPEC-011).
 *
 * Es la misma consulta que hace la pantalla del seguimiento, y por la misma
 * razon: es la que trae `assignedCourseDetail` y `assignedLevelDetail`, sin los
 * cuales no hay oferta que pedir. Vive aparte del componente porque la
 * necesitan tanto `TramiteDeSolicitud` como la resolucion del retorno del pago.
 *
 * **Lanza `SinTramite`** —y ya no un error propio— desde SPEC-016: quien lo
 * atrapa son las pantallas del bloque 6, que desde esa spec sirven a los dos
 * tramites y no pueden nombrar la solicitud en el `catch`.
 */
export async function traerSolicitud(
  solicitudes: ApplicationService,
  id: string,
): Promise<Application> {
  if (!id) throw new SinTramite();

  const respuesta = (await firstValueFrom(solicitudes.getById(id)).catch(
    () => null,
  )) as HttpResponse | null;

  if (respuesta?.code !== 200 || !respuesta.response) throw new SinTramite();
  return respuesta.response as Application;
}
